import { ErrorBus } from 'helpers/ErrorBus';

export const errorBus = new ErrorBus();
